import styled, { css } from 'styled-components';

import { flexAsRow } from '@components/Styled/mixins';

const ModelChipWrapper = styled.div`
  ${flexAsRow(1)};

  align-items: center;
  align-self: end;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}px) {
    > p {
      display: none;
    }
  }
`;

const OptionButton = styled.button`
  all: unset;
  cursor: pointer;

  ${({ theme, isSelected }) => css`
    border-radius: ${theme.spacing(1)};
    padding: ${`${theme.spacing(0.5)} ${theme.spacing(0.5)} 0 ${theme.spacing(0.5)}`};
    box-shadow: ${theme.shadows.sm[2]};
    background-color: ${isSelected
    ? theme.colors.secondary.lightAqua : theme.colors.neutral.chromatic[100]};
  `};
`;

export { OptionButton, ModelChipWrapper };
